import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Gallery from "../pages/gallery/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/galeria",
    element: <Gallery />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
